export const NOTIFICATION_SETTINGS_TYPES = {
    EMAIL: 'EMAIL',
    TELEGRAM: 'TELEGRAM',
    SLACK: 'SLACK',
    WHATSAPP: 'WHATSAPP',
    PHONE: 'PHONE',
    SMS: 'SMS',
}